import { Base64 } from 'js-base64';

function JSON_stringify(s, emit_unicode) {
    var json = JSON.stringify(s);
    return emit_unicode ? json : json.replace(/[\u007f-\uffff]/g,
        function (c) {
            return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
        }
    );
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default function useSaveUrl(moduleName) {

    return {
        created() {
            if (this.$root.env === 'frontend') {
                let mapData = getParameterByName('mapData', window.location.href);
                if (!mapData) {
                } else {
                    try {
                        let mapDataObject = JSON.parse(Base64.decode(mapData));
                        this.setObjectData(mapDataObject)
                        setTimeout(() => {
                            this.setObjectData(mapDataObject);
                        }, 1000) // TODO order set causes wrong view without double recheck
                    } catch (e) {
                        console.log(mapData)
                        console.error(e)
                    }
                }

                this.$nextTick(()=>{
                    this.$emit('onTemplateDataUrl', !!mapData)
                })
            }
        },
        mounted() {
            this.$nextTick(() => {
                if (this.$root.env === 'frontend') {
                    this.$store.subscribe((mutation, state) => {
                        try {
                            let b64 = Base64.encodeURI(JSON_stringify({...state[moduleName]}))
                            let newUrl = `?mapData=${b64}`;
                            window.history.replaceState(null, document.title, newUrl);
                        } catch (e) {
                            console.error(e)
                        }
                    });
                }
            })
        },
        methods:{
            setObjectData(object) {
                this.$nextTick(() => {
                    if (object) {
                        Object.keys(object).map(key => {
                            if (key !== 'mapBounds') {
                                this.$set(this, key, object[key]);
                            }
                        });
                        this.$forceUpdate();
                    }
                })
            },
        }
    }
}